module.exports = __webpack_public_path__ + "static/media/background-on-demand.009a860a.svg";